var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.357,
    height: 24.116,
    viewBox: "0 0 30.357 24.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speaker-filled-audio-tool",
    transform: "translate(0 -9.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87680",
    "data-name": "Path 87680",
    d: "M15.188,31.085a1.379,1.379,0,0,1-2.259,1.061L5.393,25.9H1.379A1.378,1.378,0,0,1,0,24.523V19.031a1.379,1.379,0,0,1,1.379-1.379H5.393l7.537-6.245a1.379,1.379,0,0,1,2.259,1.062V31.085Zm5.3-2.154c-.034,0-.066,0-.1,0a1.377,1.377,0,0,1-.975-.4l-.184-.185a1.378,1.378,0,0,1-.133-1.8,8.016,8.016,0,0,0-.212-9.823,1.378,1.378,0,0,1,.095-1.844l.184-.184a1.348,1.348,0,0,1,1.044-.4,1.38,1.38,0,0,1,1,.5,11.041,11.041,0,0,1,.287,13.58A1.379,1.379,0,0,1,20.486,28.931Zm5.7,4.26a1.38,1.38,0,0,1-1,.488h-.058a1.378,1.378,0,0,1-.975-.4l-.181-.181a1.379,1.379,0,0,1-.08-1.862,14.691,14.691,0,0,0-.243-19.2,1.379,1.379,0,0,1,.055-1.887l.181-.181A1.342,1.342,0,0,1,24.9,9.565a1.379,1.379,0,0,1,.991.462,17.7,17.7,0,0,1,.29,23.164Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.64beec48b234388f765e370e566d8c81.svg";
export { ForwardRef as ReactComponent };